import {
  getEventAggregate,
  getUpcomingFeaturedPublishedEvents,
  getUpcomingPublishedEventsInRange,
} from '../../../services/firestore';
import {
  fetchUnifiedEventsInRange,
  fetchUnifiedFeaturedEvents,
  isUnifiedEventsApiEnabled,
} from '../../../services/unifiedEventsApi';

export const firestoreFeedAdapter = {
  getAggregate: getEventAggregate,
  getFeatured: (opts) => getUpcomingFeaturedPublishedEvents(opts),
  getRange: (opts) => getUpcomingPublishedEventsInRange(opts),
};

export const unifiedFeedAdapter = {
  getAggregate: getEventAggregate,
  getFeatured: (opts) => fetchUnifiedFeaturedEvents(opts),
  getRange: (opts) => fetchUnifiedEventsInRange(opts),
};

export function getEventFeedAdapter() {
  return isUnifiedEventsApiEnabled() ? unifiedFeedAdapter : firestoreFeedAdapter;
}
